import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";

import "./index.scss";

export default function MessageThreadBar({
  count,
  onOpen,
  className = "",
}) {
  if (!Number.isFinite(count) || count <= 0) {
    return null;
  }
  return (
    <div className={classNames("c-message__reply_bar c-message_kit__thread_replies", className)}>
      <button
        type="button"
        className="c-message__reply_link"
        onClick={onOpen}
        aria-label={`View ${count} ${count === 1 ? "comment" : "comments"}`}
      >
        <span className="c-message__reply_count">{count}</span>
        <span className="c-message__reply_label">{count === 1 ? "comment" : "comments"}</span>
        <span className="c-message__reply_separator">·</span>
        <span className="c-message__reply_action">View thread</span>
        <span className="c-message__reply_chevron" aria-hidden="true">›</span>
      </button>
    </div>
  );
}

MessageThreadBar.propTypes = {
  count: PropTypes.number,
  onOpen: PropTypes.func,
  className: PropTypes.string,
};

MessageThreadBar.defaultProps = {
  count: 0,
  onOpen: undefined,
  className: "",
};


